import { TableCell, TableRow } from "@capacit-com/lara-law-shared-ui";
import { Skeleton } from "@capacit-com/lara-law-shared-ui";

export const ConversationTableRowSkeleton = () => {
  return (
    <TableRow className="p-2 h-16">
      <TableCell className="w-4/12">
        <div className="flex flex-col items-start">
          <Skeleton className="h-4 w-[80%] mb-1" />
          <Skeleton className="h-4 w-[50%]" />
        </div>
      </TableCell>
      <TableCell className="w-2/12">
        <div className="flex items-center ">
          <Skeleton className="h-4 w-[80%]" />
        </div>
      </TableCell>
      <TableCell className="w-2/12">
        <div className=" flex items-center">
          <Skeleton className="h-4 w-[75%]" />
        </div>
      </TableCell>
      <TableCell className="w-2/12">
        <div className=" flex items-center">
          <Skeleton className="h-4 w-[80%]" />
        </div>
      </TableCell>
      <TableCell className="w-1/12">
        <div className=" flex items-center">
          <Skeleton className="h-5 w-[90%]" />
        </div>
      </TableCell>
      <TableCell className="w-1/12">
        <div className=" flex items-center">
          <Skeleton className="h-5 w-[90%]" />
        </div>
      </TableCell>
    </TableRow>
  );
};
